import { useEffect, useRef } from "react";

export default function HtmlInjector({ headHtml, footerHtml }) {
  const headNodesRef = useRef([]);
  const footerNodesRef = useRef([]);

  useEffect(() => {
    // Helper: Inject HTML with proper script execution
    const injectHtml = (htmlString, parentElement, nodesRef) => {
      if (!htmlString) return;

      const template = document.createElement("template");
      template.innerHTML = htmlString;

      Array.from(template.content.childNodes).forEach(node => {
        let appendedNode;

        if (node.tagName === "SCRIPT") {
          const script = document.createElement("script");
          Array.from(node.attributes).forEach(attr => {
            script.setAttribute(attr.name, attr.value);
          });
          script.textContent = node.textContent;
          appendedNode = parentElement.appendChild(script);
        } else {
          appendedNode = parentElement.appendChild(node);
        }

        nodesRef.current.push(appendedNode);
      });
    };

    // Cleanup previously injected nodes
    const cleanupNodes = nodesRef => {
      nodesRef.current.forEach(node => {
        if (node && node.parentElement) {
          node.parentElement.removeChild(node);
        }
      });
      nodesRef.current = [];
    };

    // First cleanup any existing injections
    cleanupNodes(headNodesRef);
    cleanupNodes(footerNodesRef);

    // Inject into HEAD
    injectHtml(headHtml, document.head, headNodesRef);

    // @NOTE: Commenting this out. We dangerouslySetInnerHTML the footerHtml instead.
    // Inject into end of page into #inject-footer-html
    // injectHtml(
    //   footerHtml,
    //   document.getElementById("inject-footer-html"),
    //   footerNodesRef
    // );

    // Cleanup on unmount or dependency change
    return () => {
      cleanupNodes(headNodesRef);
      cleanupNodes(footerNodesRef);
    };
  }, [headHtml, footerHtml]);

  return null;
}
